import { createReducer, on } from '@ngrx/store';
import { withEntityReducer } from '@aston/foundation';

import * as featureActions from './actions';
import { initialState, ISubsidiariesState } from './state';


// declare our fully typed reducer
export const SubsidiariesStoreReducer = createReducer<ISubsidiariesState>(
	initialState,

	...withEntityReducer<ISubsidiariesState>('subsidiaries', featureActions.SubsidiariesActions),

	on(featureActions.LoadSubsidiariesSuccess, (state, action) => ({
		...state,
		hasLoadedOnce: true,
		hasPendingItems: action.hasPendingItems,
	})),
);
